import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createSettingPrice = (data) => ({
  type: ActionTypes.SETTING_PRICE_CREATE,
  payload: {
    data,
  },
});

export const updateSettingPrice = (id, data) => ({
  type: ActionTypes.SETTING_PRICE_UPDATE,
  payload: {
    id,
    data,
  },
});

/* Events */

export const createSettingPriceRequested = (data) => ({
  type: ActionTypes.SETTING_PRICE_CREATE_REQUESTED,
  payload: {
    data,
  },
});

export const createSettingPriceSucceeded = (settingPrice) => ({
  type: ActionTypes.SETTING_PRICE_CREATE_SUCCEEDED,
  payload: {
    settingPrice,
  },
});

export const createSettingPriceFailed = (error) => ({
  type: ActionTypes.SETTING_PRICE_CREATE_FAILED,
  payload: {
    error,
  },
});

export const createSettingPriceReceived = (settingPrice) => ({
  type: ActionTypes.SETTING_PRICE_CREATE_RECEIVED,
  payload: {
    settingPrice,
  },
});

export const updateSettingPriceRequested = (id, data) => ({
  type: ActionTypes.SETTING_PRICE_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateSettingPriceSucceeded = (settingPrice) => ({
  type: ActionTypes.SETTING_PRICE_UPDATE_SUCCEEDED,
  payload: {
    settingPrice,
  },
});

export const updateSettingPriceFailed = (error) => ({
  type: ActionTypes.SETTING_PRICE_UPDATE_FAILED,
  payload: {
    error,
  },
});

export const updateSettingPriceReceived = (settingPrice) => ({
  type: ActionTypes.SETTING_PRICE_UPDATE_RECEIVED,
  payload: {
    settingPrice,
  },
});
